import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();
export class ZIDXAccountZapierCreateLeadTest implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountZapierCreateLeadTestContainer";
    }
    render(){
        // console.log("zapier create lead test");
    }
}
